import type { Components, Theme } from "@mui/material/styles";
import getAlertOverrides from "./AlertOverrides";
import getCardOverrides from "./CardOverrides";
import getChipOverrides from "./ChipOverrides";
import getDialogOverrides from "./DialogOverrides";
import getPopperOverrides from "./PopperOverrides";

export default function getComponentsOverrides(theme: Theme): Components {
  return {
    ...getDialogOverrides(theme),
    ...getPopperOverrides(theme),
    ...getAlertOverrides(theme),
    ...getCardOverrides(theme),
    ...getChipOverrides(theme),
  } as Components;
}
